export default __webpack_public_path__ + "static/media/gallery - story - other (1)_00.786829fc.jpg";